import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
function LoadingIndicatorDotsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelement(2, "div")(3, "div")(4, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("loading-indicator ", ctx_r0.size, "");
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand);
    i0.ɵɵattribute("aria-label", ctx_r0.label ? ctx_r0.label : null);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("bounce1 ", ctx_r0.color, " ", ctx_r0.size, "");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("bounce2 ", ctx_r0.color, " ", ctx_r0.size, "");
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("bounce3 ", ctx_r0.color, " ", ctx_r0.size, "");
  }
}
function LoadingIndicatorDotsComponent_ng_container_1_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LoadingIndicatorDotsComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 2);
    i0.ɵɵelement(3, "circle", 3)(4, "circle", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LoadingIndicatorDotsComponent_ng_container_1_p_5_Template, 2, 1, "p", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("spinnerContainer spinner ", ctx_r0.size, " ", ctx_r0.colorVariant, "");
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand);
    i0.ɵɵattribute("data-stb-spinner", true)("aria-label", ctx_r0.label ? ctx_r0.label : null);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("spinner ", ctx_r0.colorVariant, "");
    i0.ɵɵattribute("viewBox", "-" + ctx_r0.spinnerSize / 2 + " -" + ctx_r0.spinnerSize / 2 + " " + ctx_r0.spinnerSize + " " + ctx_r0.spinnerSize)("height", ctx_r0.spinnerSize)("width", ctx_r0.spinnerSize);
    i0.ɵɵadvance();
    i0.ɵɵattribute("cx", 0)("cy", 0)("r", ctx_r0.innerRadius)("stroke-width", ctx_r0.stroke);
    i0.ɵɵadvance();
    i0.ɵɵattribute("cx", 0)("cy", 0)("r", ctx_r0.innerRadius)("stroke-width", ctx_r0.stroke);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.size !== "small" && ctx_r0.label);
  }
}
let LoadingIndicatorDotsComponent = /*#__PURE__*/(() => {
  class LoadingIndicatorDotsComponent {
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.color = 'default';
      this.colorVariant = 'default';
      this.size = 'medium';
      this.rebrand = false;
      this.label = this.rebrand ? 'Loading…' : '';
      this.getSpinnerSize = size => {
        if (size === 'large') return 96;
        if (size === 'medium') return 48;
        if (size === 'small') return 24;
        // special size options for when used inside buttons
        if (size === 'buttonLarge') return 24;
        if (size === 'buttonMedium') return 20;
        if (size === 'buttonSmall') return 18;
        return 96;
      };
      this.getStrokeSize = size => {
        switch (size) {
          case 'small':
          case 'medium':
            return this.getSpinnerSize(size) / 8;
          case 'large':
          default:
            return this.getSpinnerSize(size) / 10;
        }
      };
    }
    ngOnInit() {
      this.updateSize(this.size);
    }
    ngOnChanges(changes) {
      if (changes.size?.currentValue) {
        this.updateSize(changes.size.currentValue);
      }
    }
    updateSize(size) {
      if (size) {
        this.spinnerSize = this.getSpinnerSize(size);
        this.stroke = this.getStrokeSize(size);
        this.cx = this.spinnerSize / 2;
        this.cy = this.spinnerSize / 2;
        /**
         * the dynamic value of innerRadius is used in index.css as a value for --spinner-radius.
         * if the values returned in getSpinnerSize are changed, --spinner-radius must be updated
         *  with the new value of innerRadius.
         */
        this.innerRadius = this.spinnerSize / 2 - this.stroke / 2;
        this.cdRef.detectChanges();
      }
    }
  }
  LoadingIndicatorDotsComponent.ɵfac = function LoadingIndicatorDotsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoadingIndicatorDotsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  LoadingIndicatorDotsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoadingIndicatorDotsComponent,
    selectors: [["stb-loading-indicator-dots"]],
    inputs: {
      color: "color",
      colorVariant: "colorVariant",
      size: "size",
      rebrand: "rebrand",
      label: "label"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 2,
    vars: 2,
    consts: [[4, "ngIf"], ["role", "progressbar", "aria-busy", "true"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg"], ["fill", "none", 1, "spinnerTrack"], ["fill", "none", 1, "spinnerInMotion"], ["class", "font-paragraph font-weight-400", 4, "ngIf"], [1, "font-paragraph", "font-weight-400"]],
    template: function LoadingIndicatorDotsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, LoadingIndicatorDotsComponent_ng_container_0_Template, 5, 18, "ng-container", 0)(1, LoadingIndicatorDotsComponent_ng_container_1_Template, 6, 23, "ng-container", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.rebrand);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.rebrand);
      }
    },
    dependencies: [i1.NgIf],
    styles: [".spinnerContainer[data-stb-spinner=true][_ngcontent-%COMP%]{--spinner-container-size: var(--p-spacing-rem-96);--spinner-radius: 44;--spinner-perimeter: (2 * pi * var(--spinner-radius));--spinner-perimeter-full: calc(var(--spinner-perimeter) * 1px);--spinner-perimeter-fraction: calc(.001 * var(--spinner-perimeter) * 1px);--spinner-track-color: var(--p-color-static-grey-background);--spinner-ticker-color: var(--p-color-static-red-foreground);--text-color: var(--p-color-text-primary);align-items:center;color:var(--text-color);display:flex;flex-direction:column;gap:var(--p-spacing-08);width:var(--spinner-container-size)}.spinnerContainer[data-stb-spinner=true][_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:var(--p-spacing-08);white-space:nowrap}.spinnerContainer[data-stb-spinner=true].xxsmall[_ngcontent-%COMP%]{--spinner-radius: 8;--spinner-container-size: var(--p-spacing-rem-16)}.spinnerContainer[data-stb-spinner=true].xsmall[_ngcontent-%COMP%]{--spinner-radius: 10;--spinner-container-size: 1.375rem}.spinnerContainer[data-stb-spinner=true].small[_ngcontent-%COMP%]{--spinner-radius: 11;--spinner-container-size: var(--p-spacing-rem-24)}.spinnerContainer[data-stb-spinner=true].medium[_ngcontent-%COMP%]{--spinner-radius: 24;--spinner-container-size: var(--p-spacing-rem-48)}.spinnerContainer[data-stb-spinner=true].medium[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:1rem;line-height:1.375rem}.spinnerContainer[data-stb-spinner=true].buttonSmall[_ngcontent-%COMP%]{--spinner-radius: 18;--spinner-container-size: var(--p-spacing-rem-18)}.spinnerContainer[data-stb-spinner=true].buttonMedium[_ngcontent-%COMP%]{--spinner-radius: 20;--spinner-container-size: var(--p-spacing-rem-20)}.spinnerContainer[data-stb-spinner=true].buttonLarge[_ngcontent-%COMP%]{--spinner-radius: 24;--spinner-container-size: var(--p-spacing-rem-24)}.spinnerContainer[data-stb-spinner=true].onRed[_ngcontent-%COMP%]{--spinner-track-color: var(--p-color-static-grey-background);--spinner-ticker-color: var(--p-color-static-grey-foreground);--text-color: var(--p-color-text-primary)}.spinnerContainer[data-stb-spinner=true][_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_rotate 5s linear infinite}.spinnerContainer[data-stb-spinner=true][_ngcontent-%COMP%]   .spinnerTrack[_ngcontent-%COMP%]{stroke:var(--spinner-track-color)}.spinnerContainer[data-stb-spinner=true][_ngcontent-%COMP%]   .spinnerInMotion[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_spin infinite 6s ease-in-out;stroke:var(--spinner-ticker-color);stroke-dasharray:var(--spinner-perimeter);transform-origin:0 0}@keyframes _ngcontent-%COMP%_spin{0%{stroke-dasharray:var(--spinner-perimeter-full),var(--spinner-perimeter-fraction);transform:rotate(0)}50%{stroke-dasharray:var(--spinner-perimeter-fraction),var(--spinner-perimeter-full);transform:rotate(720deg)}to{stroke-dasharray:var(--spinner-perimeter-full),var(--spinner-perimeter-fraction);transform:rotate(1080deg)}}@keyframes _ngcontent-%COMP%_rotate{0%{transform:rotate(0)}50%{transform:rotate(720deg)}to{transform:rotate(1080deg)}}.loading-indicator[_ngcontent-%COMP%]{text-align:center;display:flex;justify-content:space-between}.loading-indicator[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-left:2px;border-radius:50%;display:inline-block;animation:_ngcontent-%COMP%_sk-bouncedelay 1.4s infinite ease-in-out both}.loading-indicator[_ngcontent-%COMP%] > div.red[_ngcontent-%COMP%], .loading-indicator[_ngcontent-%COMP%] > div.default[_ngcontent-%COMP%]{background-color:#bf0900}.loading-indicator[_ngcontent-%COMP%] > div.white[_ngcontent-%COMP%]{background-color:#fff}.loading-indicator[_ngcontent-%COMP%] > div.legacy-green[_ngcontent-%COMP%]{background-color:#6c8524}.loading-indicator[_ngcontent-%COMP%]   .bounce1[_ngcontent-%COMP%]{animation-delay:0s}.loading-indicator[_ngcontent-%COMP%]   .bounce2[_ngcontent-%COMP%]{animation-delay:.2s}.loading-indicator[_ngcontent-%COMP%]   .bounce3[_ngcontent-%COMP%]{animation-delay:.4s}.loading-indicator.small[_ngcontent-%COMP%]{width:60px}.loading-indicator.small[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:16px;height:16px}.loading-indicator.medium[_ngcontent-%COMP%]{width:80px}.loading-indicator.medium[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:24px;height:24px}.loading-indicator.large[_ngcontent-%COMP%]{width:110px}.loading-indicator.large[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:32px;height:32px}@keyframes _ngcontent-%COMP%_sk-bouncedelay{0%,50%,to{transform:scale(0)}50%{transform:scale(1)}}"]
  });
  return LoadingIndicatorDotsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingIndicatorDotsModule = /*#__PURE__*/(() => {
  class LoadingIndicatorDotsModule {}
  LoadingIndicatorDotsModule.ɵfac = function LoadingIndicatorDotsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoadingIndicatorDotsModule)();
  };
  LoadingIndicatorDotsModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LoadingIndicatorDotsModule
  });
  LoadingIndicatorDotsModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return LoadingIndicatorDotsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of loading-indicator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingIndicatorDotsComponent, LoadingIndicatorDotsModule };
